var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量改价",
        visible: _vm.dialogVisible,
        width: "900px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mb20",
              attrs: { model: _vm.form, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "债权额档位：", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请选择债权额档位" },
                      on: { change: _vm.onDebtRatioChange },
                      model: {
                        value: _vm.form.debtRatio,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "debtRatio", $$v)
                        },
                        expression: "form.debtRatio",
                      },
                    },
                    _vm._l(_vm.tierList, function (tier) {
                      return _c("el-option", {
                        key: tier.debtRatio,
                        attrs: {
                          label: (tier.debtRatio * 100).toFixed(0) + "%",
                          value: tier.debtRatio,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上浮参数：" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { precision: 4, step: 0.01, min: -10, max: 10 },
                    model: {
                      value: _vm.form.markupParam,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "markupParam", $$v)
                      },
                      expression: "form.markupParam",
                    },
                  }),
                  _c("span", { staticClass: "tip-text ml10" }, [
                    _vm._v("（支持正数、负数，仅本次生效）"),
                  ]),
                ],
                1
              ),
              _vm.form.debtRatio
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.calcLoading },
                          on: { click: _vm.handleCalc },
                        },
                        [_vm._v("预计算售价")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.calcItems.length > 0
            ? _c(
                "div",
                [
                  _vm.errorCount > 0
                    ? _c("el-alert", {
                        staticClass: "mb10",
                        attrs: {
                          title:
                            "共 " +
                            _vm.errorCount +
                            " 个商品成本价<=0，已跳过计算",
                          type: "warning",
                          "show-icon": "",
                          closable: false,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.calcItems,
                        border: "",
                        "max-height": "400",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "productId",
                          label: "商品ID",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品图", width: "70" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                    },
                                    attrs: {
                                      src: scope.row.productImage,
                                      fit: "contain",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          359777779
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productName",
                          label: "商品名称",
                          "min-width": "180",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "costPrice",
                          label: "成本价",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "oldPrice",
                          label: "原售价",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "预计算售价", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.isError
                                    ? _c(
                                        "span",
                                        { staticClass: "error-text" },
                                        [_vm._v("--")]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(scope.row.calcPrice)),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          998453469
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "最终售价", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !scope.row.isError
                                    ? _c("el-input-number", {
                                        attrs: {
                                          precision: 2,
                                          min: 0.01,
                                          max: 999999,
                                          size: "small",
                                          "controls-position": "right",
                                        },
                                        model: {
                                          value: scope.row.calcPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "calcPrice",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.calcPrice",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "error-text" },
                                        [_vm._v("无法计算")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1287455531
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.isError
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "small",
                                          },
                                        },
                                        [_vm._v("异常")]
                                      )
                                    : _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "small",
                                          },
                                        },
                                        [_vm._v("正常")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1090423623
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.submitLoading,
                disabled: !_vm.canSubmit,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("提交改价")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }